import styled from 'styled-components';
import {text, top} from '../smsEditor/SmsEditor.css';

export const title=styled(top)`
`;

export const name=styled(text)`
`;